import { AlertColor } from '@mui/material';
import { logWarn } from './logger.ts';

// A global variable to store the toast function
let globalShowToast: ((message: string, severity: AlertColor) => void) | null = null;

export const registerToastHandler = (
  handler: ((message: string, severity: AlertColor) => void) | null
) => {
  globalShowToast = handler;
};

export const showToast = (message: string, severity: AlertColor = 'error') => {
  if (globalShowToast) {
    globalShowToast(message, severity);
  } else {
    logWarn('Toast handler not registered yet. Message:', message);
  }
};
